import { z } from "zod";
export const WarmUpResponseSchema = z.object({
  status: z.union([z.literal("ok"), z.literal("warmup_disabled")]),
});
export type WarmUpResponse = z.infer<typeof WarmUpResponseSchema>;
